<template>
    <div 
        class="exploitation-moteur"
        :class="isAdvanced?'advanced-section':''"
    >
        <h2 
            v-if="isAdvanced"
            class="step-title"
        >
            Application et Régulation
        </h2>
        <h2 
            v-else
            class="step-title"
        >
            Données d'exploitation
        </h2>
        <el-form-item 
            v-if="isAdvanced"
            prop="application_type" 
            class="formSelect" 
            :show-message="showMessage('application_type')" 
            label="Type d'application"
        >
            <el-select name="application" id="application" v-model="motorForm.application_type" placeholder="Choisissez un type d'application" required>
                <el-option
                    v-for="label, opt  in applications"
                    :key="opt"
                    :label="label"
                    :value="opt"
                >
                    {{label}}
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item 
            v-if="isAdvanced"
            prop="regulation_type" 
            class="formSelect" 
            :show-message="showMessage('regulation_type')" 
            label="Type de régulation"
        >
            <el-select 
                name="regulation" 
                id="regulation" 
                v-model="motorForm.regulation_type" 
                placeholder="Choisissez un type de régulation" 
                :disabled="disableRegulations"
                required
            >
                <el-option
                    v-for="label, opt  in regulations"
                    :key="opt"
                    :label="label"
                    :value="opt"
                >
                    {{label}}
                </el-option>
            </el-select>
        </el-form-item>
        <el-row>
            <el-form-item
                label="Durée de fonctionnement (h/an)"
                prop="annual_working_time"
                :show-message="showMessage('annual_working_time')"
            >
                <el-input v-model="motorForm.annual_working_time" required></el-input>
            </el-form-item>
            <p class="info">
                La valeur correspondant à une année entière serait 8760.
            </p>
        </el-row>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    data() {
        return {
        };
    },
    props: {
        motorForm: {
            type: Object,
            required: true
        },
        isAdvanced:{
            type: Boolean,
            required: false,
            default: false,
        }
    },
    computed: {
        ...mapGetters([
            'getText',
            'getTextArray',
            'getLangage'
        ]),
        applications(){
            return this.$store.state.applications;
        },
        disableRegulations(){
            return this.motorForm.application_type === ''
        },
        regulations(){
            if(!this.disableRegulations){
                return this.$store.state.regulations[this.motorForm.application_type];
            }
            return [];
        },
    },
    methods: {
        showMessage(el) {
            if (this.motorForm[el].length)
                return true;
            return false;
        },
    }
};
</script>

<style lang="less">

.exploitation-moteur {
    width: 100%;
    padding: 5px 15px 40px;
    border: 5px solid #efefef !important;

    // .data-estimation {
    //     .icon-plus, .icon-minus {
    //         font-size: 25px;
    //         line-height: 25px;
    //         margin-top: 25px;
    //         margin-left: 10px;
    //     }
    // }
    // .data-graph-placeholder {
    //     margin-top: 50px;
    //     background: #e1e1e1;
    //     text-align: center;
    //     min-height: 300px;
    //     padding-top: 100px;
    //     color: #666;

    //     .icon-stats {
    //         font-size: 40px;
    //     }
    // }
    .info {
        margin: 40px 0 0 5%;
        font-size: 12px;
    }
}

// .modal-exploitation-data {
//     #graph {
//         min-width: 800px;
//         width: 90%;
//         .modebar--hover {
//             display: none;
//         }
//     }
//     .modal-exploitation-saisie {
//         width: 600px;
//         .plot-container {
//             display: none;
//         }
//     }
//     // width: 880px;
//     .icon-plus, .icon-minus {
//         display: block;
//         width: 100%;
//         text-align: center;
//         font-size: 25px;
//         line-height: 25px;
//         margin-top: 25px;
//         margin-left: 10px;
//     }
// }

// .dialogButton {
//     margin: 6px 8px 50px 5%;
// }
// .modal-exploitation-actions {
//     padding-right: 20px !important;
//     padding-bottom: 20px !important;
// }

// .el-radio.is-checked {
//     .el-radio__inner {
//     }
//     .el-radio__label {
//     }
// }

// .el-dialog__body {
//     text-align: center !important;
//     .el-upload__tip {
//         margin-bottom: 20px;
//     }
//     .el-upload-dragger:hover {
//     }
//     .icon {
//         margin-top: 55px;
//         .icon-minus {
//             font-size: 27px;
//         }
//         .icon-plus {
//             font-size: 27px;
//         }
//     }
//     .spaceTop {
//         margin-top: 40px;
//     }
// }


// .radio {
//     display: flex;
//     justify-content: flex-start;
//     flex-direction: row;
//     margin: 20px auto;
//     width: 90%;
//     flex-wrap: wrap;
//     align-items: center;
//     label {
//         margin-left: 0 !important;
//         margin-right: 20px;
//     }
// }
</style>



// WEBPACK FOOTER //
// src/components/partials/wizard/DonneesForm.vue